exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3LA-50e9JRyUX6oHm1uDEU{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir=ltr] ._18Tuwgw6ODu0BJTLSLrK3G{margin-right:5px}html[dir=rtl] ._18Tuwgw6ODu0BJTLSLrK3G{margin-left:5px}.DlUVpkElg7f0iKOqMdmwQ{word-break:break-all}", ""]);
// Exports
exports.locals = {
	"webUrlLocationTokensContainer": "_3LA-50e9JRyUX6oHm1uDEU",
	"webUrlLocationToken": "_18Tuwgw6ODu0BJTLSLrK3G",
	"linkLocation": "DlUVpkElg7f0iKOqMdmwQ"
};